// `@flexcompute/thread-graph/react` — FXC-8538 (Warp).
//
// React layer: the shared <ThreadGraph> component, the pluggable
// renderer contract + registry, and the built-in renderers. Importing
// this entry registers the built-ins (`force`).

import { registerRenderer } from "./rendererRegistry";
import { ForceRenderer } from "./ForceRenderer";
import { HierarchicalRenderer } from "./HierarchicalRenderer";
import { WebGLRenderer } from "./WebGLRenderer";

// Register built-in renderers on import.
registerRenderer("force", ForceRenderer);
registerRenderer("hierarchical", HierarchicalRenderer);
registerRenderer("webgl", WebGLRenderer);

export { ThreadGraph, type ThreadGraphProps } from "./ThreadGraph";
export {
  LineageExplorer,
  type LineageExplorerProps,
  type LineageSelection,
  type ClusterMode,
  type ClusterInfo,
} from "./LineageExplorer";
export { ForceRenderer } from "./ForceRenderer";
export { HierarchicalRenderer } from "./HierarchicalRenderer";
export { WebGLRenderer } from "./WebGLRenderer";
export { layoutWithElk, type ElkLayout, type ElkDirection } from "./elkLayout";
export {
  registerRenderer,
  getRenderer,
  rendererNames,
} from "./rendererRegistry";
export type {
  GraphRenderer,
  GraphRendererProps,
  GraphControls,
  GraphGroup,
} from "./GraphRenderer";
export { convexHull } from "./hull";

// Re-export the core model for convenience so a React consumer can pull
// types + adapters from one import if it prefers.
export type { Graph, GraphNode, GraphEdge } from "../core/types";
